import { defineMessages } from 'react-intl';

export default defineMessages({
  AddButton: {
    id: 'Employers.AddButton.Label',
    defaultMessage: 'Add Employer',
  },
  AddMoreButton: {
    id: 'Employers.AddMoreButton.Label',
    defaultMessage: 'Add Employer',
  },
  RemoveButton: {
    id: 'Employers.RemoveButton.Label',
    defaultMessage: 'Remove',
  },
  Caption: {
    id: 'Employers.Caption',
    defaultMessage: 'Employer {index}',
  },
  JobNoPriorWorkExperience: {
    id: 'Employers.NoExperience',
    defaultMessage: 'No prior work experience',
  },
  CompanyName: {
    id: 'Employers.CompanyName',
    defaultMessage: 'Company Name',
  },
  JobTitle: {
    id: 'Employers.JobTitle',
    defaultMessage: 'Job Title',
  },
  StartDate: {
    id: 'Employers.StartDate',
    defaultMessage: 'Start Date',
    errorMessage: 'Start date must be before End date',
  },
  IsCurrent: {
    id: 'Employers.IsCurrent',
    defaultMessage: 'Current',
  },
  EndDate: {
    id: 'Employers.EndDate',
    defaultMessage: 'End Date',
    errorMessage: 'End date must be after Start date',
  },
  SummaryDuties: {
    id: 'Employers.SummaryDuties',
    defaultMessage: 'Brief summary of job duties and responsibilities',
  },
  Title: {
    id: 'Employers.Title',
    defaultMessage: 'List up to your last 4 employers (if applicable)',
  },
  ExperienceValidationMessage: {
    id: 'Employers.ExperienceValidationMessage',
    defaultMessage: 'Please complete this required field.',
  },
});
